import {
    FETCH_INVOICE_DETAILS_STARTED,
    FETCH_INVOICE_DETAILS_SUCCESS,
    FETCH_INVOICE_DETAILS_FAILED,
} from "../actions/types/invoice.types";

const initialState = {
    userProfile: {},
    settings: {},
    invoice: {},
    fetchInvoiceDetailsState: "loading",
    errorMessage: "",
};

const invoicePreviewReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_INVOICE_DETAILS_STARTED:
            return {
                ...state,
                fetchInvoiceDetailsState: "loading",
            };

        case FETCH_INVOICE_DETAILS_SUCCESS:
            return {
                ...state,
                fetchInvoiceDetailsState: "success",
                invoice: { ...payload[0]?.data?.data[0] },
                settings: { ...payload[1]?.data?.data[0] },
                userProfile: { ...payload[2]?.data?.data[0] },
            };

        case FETCH_INVOICE_DETAILS_FAILED:
            return {
                ...state,
                fetchInvoiceDetailsState: "failed",
            };

        default:
            return state;
    }
};

export { invoicePreviewReducer };
